import { ethers, makeError, toQuantity } from 'ethers';
import EventEmitter from 'events';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var Eip1193Bridge = class extends EventEmitter {
  static {
    __name(this, "Eip1193Bridge");
  }
  signer;
  provider;
  constructor(signer, provider) {
    super();
    this.signer = signer;
    this.provider = provider ?? signer.provider;
  }
  request(request) {
    return this.send(request.method, request.params || []);
  }
  async send(method, params) {
    function throwUnsupported(message) {
      const erroInfo = {
        operation: method
      };
      return makeError(
        message,
        "UNSUPPORTED_OPERATION",
        erroInfo
      );
    }
    __name(throwUnsupported, "throwUnsupported");
    let coerce = /* @__PURE__ */ __name((value) => value, "coerce");
    switch (method) {
      case "eth_gasPrice": {
        const result = (await this.provider.getFeeData()).gasPrice;
        return result ? toQuantity(result) : null;
      }
      case "eth_accounts": {
        const result = [];
        if (this.signer) {
          const address = await this.signer.getAddress();
          result.push(address);
        }
        return result;
      }
      case "eth_blockNumber": {
        return await this.provider.getBlockNumber();
      }
      case "eth_chainId": {
        const result = await this.provider.getNetwork();
        return toQuantity(result.chainId);
      }
      case "eth_getBalance": {
        const result = await this.provider.getBalance(params[0], params[1]);
        return toQuantity(result);
      }
      case "eth_getStorageAt": {
        return this.provider.getStorage(params[0], params[1], params[2]);
      }
      case "eth_getTransactionCount": {
        const result = await this.provider.getTransactionCount(
          params[0],
          params[1]
        );
        return toQuantity(BigInt(result));
      }
      case "eth_getBlockTransactionCountByHash":
      case "eth_getBlockTransactionCountByNumber": {
        const result = await this.provider.getBlock(params[0]);
        return result ? toQuantity(BigInt(result.transactions.length)) : result;
      }
      case "eth_getCode": {
        const result = await this.provider.getCode(params[0], params[1]);
        return result;
      }
      case "eth_sendRawTransaction": {
        return await this.signer.sendTransaction(params[0]);
      }
      case "eth_call": {
        return await this.provider.call(params[0]);
      }
      case "estimateGas": {
        if (params[1] && params[1] !== "latest") {
          throwUnsupported("estimateGas does not support blockTag");
        }
        const result = await this.provider.estimateGas(params[0]);
        return toQuantity(result);
      }
      case "eth_getBlockByHash":
      case "eth_getBlockByNumber": {
        if (params[1]) {
          return await this.provider.getBlock(params[0], true);
        } else {
          return await this.provider.getBlock(params[0]);
        }
      }
      case "eth_getTransactionByHash": {
        return await this.provider.getTransaction(params[0]);
      }
      case "eth_getTransactionReceipt": {
        return await this.provider.getTransactionReceipt(params[0]);
      }
      case "eth_sign": {
        if (!this.signer) {
          return throwUnsupported("eth_sign requires an account");
        }
        const address = await this.signer.getAddress();
        if (address !== ethers.getAddress(params[0])) {
          makeError(
            "account mismatch or account not found",
            "INVALID_ARGUMENT",
            { argument: "address", value: params[0] }
          );
        }
        return this.signer.signMessage(ethers.getBytes(params[1]));
      }
      case "eth_sendTransaction": {
        if (!this.signer) {
          return throwUnsupported("eth_sendTransaction requires an account");
        }
        const args = { ...params[0] };
        delete args.gas;
        const tx = await this.signer.sendTransaction(args);
        return tx.hash;
      }
      case "eth_getUncleCountByBlockHash":
      case "eth_getUncleCountByBlockNumber": {
        coerce = ethers.toQuantity;
        break;
      }
    }
    if (this.provider.send) {
      const result = await this.provider.send(method, params);
      return coerce(result);
    }
    return throwUnsupported(`unsupported method: ${method}`);
  }
};

export { Eip1193Bridge };
